"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./real.pipe'));
__export(require('./cei.pipe'));
__export(require('./telefone.pipe'));
__export(require('./cpf.pipe'));
__export(require('./cnpj.pipe'));
__export(require('./cep.pipe'));
__export(require('./br-pipes.module'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-brpipes/src/index.js
// module id = ./node_modules/ng2-brpipes/src/index.js
// module chunks = vendor